import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import _ from 'lodash'
import React, {createRef} from "react"
import {setAuctionFilter, SubjectType} from "redux/actions"
import Modal from "../../components/Modal"
import SearchSelect from "../../components/SearchSelect"
import {GlobalState} from "../../state"
import {connect} from "react-redux"
import {AuctionFilter as AuctionFilterModel} from "redux/actions"
import {Codes} from "../../domain-models"
import Trans from '../../components/Trans'

type AuctionFilterProps = {
  auctionsFilter: AuctionFilterModel
  codes: Codes
  vin?: string | null
  subjectType: SubjectType
}

type AuctionFilterState = {
  make: number | null
  model: number | null
  fuel: number | null
  body: number | null
  vin: string | null
  postalCode: string | null
  modalOpen: boolean
}

type FilterOption = {
    label?: string
}

class AuctionFilter extends React.Component<AuctionFilterProps, AuctionFilterState> {
  private vinRef = createRef<HTMLInputElement>()

  constructor(props: AuctionFilterProps) {
    super(props)

    this.state = {
      make: null,
      model: null,
      fuel: null,
      body: null,
      vin: null,
      postalCode: null,
      modalOpen: false
    }

    if (this.vinRef.current) {
      this.vinRef.current.value = this.props.vin || ''
    }
  };

  filterOptions = (search: string | null, options: any) => {
    if (!search) {
      return options
    }
    return _.filter(options, (option: FilterOption) => {
        return option && option.label && search && option.label.toLowerCase().startsWith(search.toLowerCase())
    })
  }

  setMake = async (make: number | null) => {
    this.setState({make: make})
    await this.filterAuctions()
  }

  setModel = async (model: number) => {
    this.setState({model: model})
    await this.filterAuctions()
  }

  setFuel = async (fuel: number) => {
    this.setState({fuel: fuel})
    await this.filterAuctions()
  }

  setBody = async (body: number) => {
    this.setState({body: body})
    await this.filterAuctions()
  }

  setPostalCode = async (postalCode: string) => {
    this.setState({postalCode: postalCode})
    await this.filterAuctions()
  }


  setVin = async (vin: string | null) => {
    this.setState({vin: vin})
    await this.filterAuctions()
  }

  filterAuctions = async () => {
    await setAuctionFilter(this.props.auctionsFilter, {
      Make: this.state.make,
      Model: this.state.model,
      Fuel: this.state.fuel,
      Body: this.state.body,
      Vin: (this.vinRef.current ? this.vinRef.current.value : null) || undefined,
      PostalCode: this.state.postalCode
    }, this.props.subjectType)
  }

  openModal = () => {
    this.setState({modalOpen: true})
  }

  hideModal = () => {
    this.setState({modalOpen: false})
  }

  render() {
    const filter = this.props.auctionsFilter
    const filterEnabled = filter && (filter.Body || filter.Fuel || filter.Make || filter.Model)
    const {Make, Model, Fuel, Body, PostalCodes} = this.props.codes
    const filters = (
      <div className="flex flex-col flex-wrap overflow-visible w-full h-full">
        <div className='flex flex-col w-full pb-6 p-2'>
          <input defaultValue={this.state.vin || ''} name="vin" ref={this.vinRef} type="text" placeholder="VIN" className="shadow appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
        </div>
        <div className='flex flex-col w-full pb-6 p-2'>
          <SearchSelect filterFunction={this.filterOptions} options={Make} title="Marke" labelField="label" keyField="value" setOption={this.setMake} value={this.state.make}/>
        </div>

        <div className='flex flex-col w-full pb-6 p-2'>
          <SearchSelect filterFunction={this.filterOptions} options={this.state.make ? Model[this.state.make] : []} title="Modell" labelField="label" keyField="value" setOption={this.setModel} value={this.state.model}/>
        </div>

        <div className='flex flex-col w-full pb-6 p-2'>
          <SearchSelect filterFunction={this.filterOptions} options={Fuel} title="Kraftstoff" labelField="label" keyField="value" setOption={this.setFuel} value={this.state.fuel}/>
        </div>

        <div className='flex flex-col w-full pb-6 p-2'>
          <SearchSelect pin={'bottom-0'} filterFunction={this.filterOptions} options={Body} title="Aufbau" labelField="label" keyField="value" setOption={this.setBody} value={this.state.body}/>
        </div>

        <div className='flex flex-col w-full pb-6 p-2'>
          <SearchSelect pin={'bottom-0'} filterFunction={this.filterOptions} options={PostalCodes} title="Standort" labelField="City" labelPrefix={true} keyField="PostalCode" setOption={this.setPostalCode} value={this.state.postalCode}/>
        </div>
      </div>
    )

    const header = (
      <div className="px-3 py-2 text-gray-700 font-semibold flex flex-row justify-between items-center">
        <span className='truncate'><Trans>Filter</Trans></span>
        <button onClick={this.hideModal} className={"flex border-0 font-semibold text-lg rounded text-gray-600 hover:text-gray-700 px-2 py-1"} type="button">
          <Icon icon="times"/>
        </button>
      </div>
    )

    const footer = (
      <div className="flex flex-row justify-end p-2">
        <button onClick={() => this.filterAuctions() && this.hideModal()} className={"border-0 bg-green-300 rounded text-green-800 hover:bg-green-200 font-semibold px-16 py-3 text-xl"} type="button">
          Anzeigen
        </button>
      </div>
    )

    return (
      <div className='w-full'>
        <div className='flex justify-end w-full p-2'>
          <button onClick={this.openModal} className={"rounded px-4 py-3 font-semibold whitespace-no-wrap bg-blue-800 hover:bg-blue-600" + (filterEnabled ? ' text-green-500' : ' text-blue-100')}>
            <Icon icon="filter"/>
            <span className={'hidden lg:block'}><Trans>Filter</Trans></span>
          </button>
        </div>

        {this.state.modalOpen ?
          <Modal body={filters} header={header} footer={footer} maxWidth={'lg'} classes=" h-full max-h-4/5 lg:max-h-3/5 "/> : null}
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  auctionsFilter: state.auctions.filter,
  codes: state.app.codes,
  vin: state.auctions && state.auctions.filter ? state.auctions.filter.Vin : null,
  subjectType: state.app.subjectType
}))(AuctionFilter)
